firstLineColumnOffset